import { render, staticRenderFns } from "./EDataSuccess.vue?vue&type=template&id=22bc09f5&"
import script from "./EDataSuccess.vue?vue&type=script&lang=js&"
export * from "./EDataSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports